<template>
  <div>
    <form @submit.prevent="validarCamposCuo" class="xcard" style="margin-top:0;" novalidate>
      <div v-if="cuota">
        <p> <b>Numero Cuota:</b> {{nro_cuota}}. </p>
        <p> <b>Monto Cuota:</b> {{cuota_pagar.monto}} Bs. </p>
        <p> <b>Saldo:</b> {{saldo}} Bs.</p>
      </div>

      <div class="row">
        <div class="col-sm-4">
          <div class="form-group form-group-sm" :class="{'has-error': validation.hasError('cuota.idcuota')}">
            <input type="text" v-model.trim="cuota.idcuota" class="form-control" placeholder="Id de la cuota" :disabled="true"/>
            <small>Id</small>
            <div class="error" v-if="validation.hasError('cuota.idcuota')"> {{validation.firstError('cuota.idcuota')}} </div>
          </div>
        </div>

        <div class="col-sm-4">
          <div class="form-group form-group-sm" :class="{'has-error': validation.hasError('cuota.monto')}">
            <input type="text" v-model.trim="cuota.saldo" class="form-control" placeholder="Monto cancelar" />
            <small>Monto</small>
            <div class="error" v-if="validation.hasError('cuota.monto')"> {{validation.firstError('cuota.monto')}} </div>
          </div>
        </div>

        <div class="col-sm-4">
          <div class="form-group form-group-sm" :class="{'has-error': validation.hasError('cuota.tipo_pago')}">
            <select v-model="cuota.tipo_pago" class="form-control form-control-sm">
              <option value="true">Credito</option>
              <option value="false">Contado</option>
            </select>
            <small>Tipo de pago</small>
            <div class="error" v-if="validation.hasError('cuota.tipo_pago')"> {{validation.firstError('cuota.tipo_pago')}} </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-4">
          <div class="form-group form-group-sm" :class="{'has-error': validation.hasError('cuota.monto')}">
            <Fecha :model="cuota" :valueto="'fecha_pago'" :default="cuota.fecha_pago"/>
            <small>Fecha de pago</small>
            <div class="error" v-if="validation.hasError('cuota.monto')"> {{validation.firstError('cuota.monto')}} </div>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group form-group-sm" :class="{'has-error': validation.hasError('cuota.nro_recibo')}">
            <input type="text" v-model.trim="cuota.nro_recibo" class="form-control" placeholder="Numero del recibo" />
            <small>Nro. Recibo</small>
            <div class="error" v-if="validation.hasError('cuota.nro_recibo')"> {{validation.firstError('cuota.nro_recibo')}} </div>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group form-group-sm" :class="{'has-error': validation.hasError('cuota.descripcion')}">
            <input type="text" v-model.trim="cuota.descripcion" class="form-control" placeholder="Observaciones" />
            <small>Observacion</small>
            <div class="error" v-if="validation.hasError('cuota.descripcion')"> {{validation.firstError('cuota.descripcion')}} </div>
          </div>
        </div>
      </div>

      <Alertas ref="alertar" />
      <p class="text-center">{{msg}}</p>
      <notifications group="auth2" position="bottom right" />
      <button v-show="activo" class="btn btn-azul center-block" @click="validarCamposCuo"> Registrar pago de cuota </button>
    </form>
  </div>
</template>

<script>
import { Validator } from 'simple-vue-validator'
import Fecha from '@/components/AFecha.vue'
import Alertas from '@/components/AAlertas.vue'
import {error,errorPago,parseJsonError} from '@/components/Utils.js'
import gql from 'graphql-tag'

export default {
  props:{
    cuota_pagar:{type:Object,required:true},listener:{type:Object,required:true}
  },
  data() {
    return {
      msg: '',
      activo: true,
      nro_cuota: -1,
      saldo: -1,
      cuota:{
        idcuota: -1,
        monto: -1,
        saldo: -1,
        tipo_pago: true,
        //forma_pago: true, 
        fecha_pago: null,
        nro_recibo: null,
        descripcion: null,
      }
    };
  },
  components:{Fecha,Alertas},
  watch:{
    cuota_pagar(){
      this.cuota.idcuota = this.cuota_pagar.id;
      if( !this.cuota_pagar.puede_pagar ){
        this.$notify( errorPago( 'Aun no se puede pagar cuota',window.stringifyObject(this.cuota_pagar) ) );
        return;
      }
      this.dato();
    },
    cuota:{
      deep: true,
      handler(){ 
        this.$refs.alertar.reset(); 
        window.sessionStorage.setItem("xcuota", JSON.stringify(this.cuota) );
        if( this.cuota.saldo == this.cuota_pagar.monto ) this.cuota.tipo_pago = false;
        else this.cuota.tipo_pago = true;
      }
    }
  },
  validators: {
    'cuota.idcuota'(value){ return Validator.value(value).required(); },
    'cuota.monto'(value){ return Validator.value(value).required().digit(); },
    'cuota.fecha_pago'(value){ return Validator.value(value).required(); },
    'cuota.nro_recibo'(value){ return Validator.value(value).minLength(5).required(); },
    'cuota.descripcion'(value){ return Validator.value(value).minLength(0).regex("^[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+(\\s[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+)*$"); },
  },
  methods:{
    dato(){
      if( this.cuota_pagar.id == null ) return;

      var obj = window.Object.assign({},this.cuota_pagar);
      this.cuota.monto = obj.monto;
      this.cuota.tipo_pago = true;
      this.cuota.idcuota = obj.id;
      this.cuota.fecha_pago = obj.fecha;
      this.cuota.saldo = obj.saldo;
      this.cuota.nro_recibo = '';
      this.nro_cuota = obj.nro_cuota;
      this.saldo = obj.saldo;
      delete this.cuota.id;
    },
    validarCamposCuo(){ 
      if( !this.activo ) return;
      this.activo = false;
      this.$validate().then((success) => {
        var obj = window.Object.assign({},this.cuota);
        if( success ){
          if( this.cuota.fecha_pago == "" ){
            this.$refs.alertar.invalido();
            this.$notify( error( 'Fecha','Falta la fecha del pago de cuota' ) );
            this.activo = true;
          }else{
            obj.monto = obj.saldo;
            delete obj.puede_pagar;
            delete obj.nro_cuota;
            delete obj.cancelado;
            delete obj.fecha;
            delete obj.saldo;
            delete obj.pagos;
            delete obj.__typename;
            obj.monto = parseInt( obj.monto );
            obj.tipo_pago = obj.tipo_pago=="true"? true:false;
            this.$store.state.obj = obj;
            this.$store.dispatch('quitarNulos');
            this.$refs.alertar.cargando();
            this.enviarDatos( obj )
          }
        }else{
          this.$refs.alertar.invalido();
          this.activo = true;
        }
      });
    },
    enviarDatos( obj ) {
      var vue = this;
      var sql = gql`mutation{ realizarPagoCuota(input:${window.stringifyObject(obj)}){ok,errors{message}} }`;
      vue.msg = "";
      // window.console.log(sql);

      this.$apollo.mutate({
        mutation: sql
        }).then(data => {
          if (data.data.realizarPagoCuota.ok) {
            vue.$refs.alertar.success();
            window.sessionStorage.setItem("xcuota", null);
            
            this.listener.flag = new Date().getTime();
            setTimeout(function(){  vue.activo = true; },7000)
          } else {
            var errores = JSON.stringify(data.data.realizarPagoCuota.errors);
            var obj = JSON.parse(errores);
            var vals = "Error Desconocido";
            if( obj != null ) obj.forEach(function(k) { vals += Object.values(k) + "-\n\t"; });
            vue.msg = vals;
            vue.activo = true;
            vue.$refs.alertar.invalido();
          }

          // window.console.log(data);
        }).catch(error => {
          vue.$refs.alertar.invalido();
          this.activo = true;
          window.console.error(JSON.stringify(error));
          vue.msg = error;

          this.$notify(parseJsonError(error));
        });
    }
  },
  mounted(){
    this.dato();
    /*window.console.log( "PAGAR CUOTA",window.sessionStorage.xcuota )
    window.console.log( "PAGAR CUOTAS",this.cuota_pagar )
    var cuo = this.cuota_pagar;
    if( cuo.idcuota ){
      this.cuota.idcuota = cuo.id;
      this.cuota.monto = cuo.monto;
      this.nro_cuota = cuo.nro_cuota;
      this.saldo = cuo.saldo;
      window.console.log( "jajajajajaja",window.stringifyObject(cuo) )
    }*/

    /*

    obtener los programas de cada programa
    obtener los postgrados por categoria, diplomado maestria..
    en semaforo si una meta es 0 no debe mostrarse en la table rojo. amarillo. verde

    */
    
  }
};
</script>




